"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainService = void 0;
const axios_1 = __importDefault(require("axios"));
const typedi_1 = require("typedi");
const utils_1 = require("@common/http/utils");
const translation_1 = require("@translation/services/translation");
const ga_1 = require("@common/services/ga");
/**
 * Сервис доменов
 */
let DomainService = class DomainService {
    /**
     * Конструктор
     */
    constructor() {
        this.translationService = typedi_1.Container.get(translation_1.TranslationService);
        this.gaService = typedi_1.Container.get(ga_1.GaService);
    }
    /**
     * Возвращает домены по поисковой фразе
     */
    getSearchDomains(query, offset) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/domain/search`, {
                    params: {
                        search: query,
                        offset: offset.toString(),
                    },
                });
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Резервирует домен
     */
    reserve(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/domain/reserve`, {
                    params,
                });
                this.gaService.sendAnalytics('RequestDomainReserve_standard', 'click', params.domain);
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Возвращает похожие домены
     */
    getSimilar(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/domain/similar`, {
                    params: {
                        domain,
                    },
                });
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Возвращает домены пользователя
     */
    getUserDomains() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/domain/my`);
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Загружает преимущества и недостатки домена
     */
    getDomainAchievements(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/api/v1/domain/${domain}/achievements`);
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Загружает информацию по домену в зонах третьего уровня
     */
    getThirdLevelsDomain(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios_1.default.get(`/${this.translationService.getLanguagePrefix()}/a/ajax/third-levels-domain-check?domain=${domain}`);
                return (0, utils_1.formatResponse)(response);
            }
            catch (err) {
                throw (0, utils_1.formatErrorResponse)(err);
            }
        });
    }
    /**
     * Проверяет является ли домен третьего уровня
     */
    isThirdLevelDomain(domain) {
        return domain.split('.').length > 2;
    }
};
DomainService = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [])
], DomainService);
exports.DomainService = DomainService;
